import React from 'react';
import { Platform } from 'react-native';

import { OrgLinksFooter } from '../OrgLinksFooter';

// This footer component is only present on web, not on native.
export const AppFooter = () => {
  if (Platform.OS !== 'web') return null;

  return <OrgLinksFooter />;
};
